"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PortalContext", {
  enumerable: true,
  get: function get() {
    return _portalContext.PortalContext;
  }
});
Object.defineProperty(exports, "PortalProvider", {
  enumerable: true,
  get: function get() {
    return _portalContext["default"];
  }
});
Object.defineProperty(exports, "UserContext", {
  enumerable: true,
  get: function get() {
    return _userContext.UserContext;
  }
});
Object.defineProperty(exports, "UserProvider", {
  enumerable: true,
  get: function get() {
    return _userContext["default"];
  }
});
Object.defineProperty(exports, "WidgetContext", {
  enumerable: true,
  get: function get() {
    return _widgetContext.WidgetContext;
  }
});
Object.defineProperty(exports, "WidgetProvider", {
  enumerable: true,
  get: function get() {
    return _widgetContext["default"];
  }
});
Object.defineProperty(exports, "usePortal", {
  enumerable: true,
  get: function get() {
    return _portalContext.usePortal;
  }
});
Object.defineProperty(exports, "useUser", {
  enumerable: true,
  get: function get() {
    return _userContext.useUser;
  }
});
Object.defineProperty(exports, "useWidget", {
  enumerable: true,
  get: function get() {
    return _widgetContext.useWidget;
  }
});

var _portalContext = _interopRequireWildcard(require("./portal-context"));

var _userContext = _interopRequireWildcard(require("./user-context"));

var _widgetContext = _interopRequireWildcard(require("./widget-context"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }